import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ControlsOf } from '@app/shared/forms/controls-of.form-group';
import { createSlotFormGroup, Slot, SlotFormGroup } from '@app/shared/forms/slot-form/slot.model';
import { noOverlapValidator } from './schedule.validators';

export const DAYS_OF_WEEK = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
] as const;

export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export interface Schedule {
  day: DayOfWeek;
  slots: Slot[];
}

export type SchedulesFormGroup = FormGroup<{
  collectiveSchedules: FormControl<boolean | null>;
  schedules: FormArray<
    FormGroup<{
      day: FormControl<DayOfWeek>;
      slots: FormArray<FormGroup<ControlsOf<Slot>>>;
    }>
  >;
}>;

export type ScheduleFormGroup = FormGroup<{
  day: FormControl<DayOfWeek>;
  slots: FormArray<SlotFormGroup>;
}>;

export function createScheduleFormGroupOfDay(day: DayOfWeek): ScheduleFormGroup {
  return new FormGroup(
    {
      day: new FormControl<DayOfWeek>(day, { nonNullable: true }),
      slots: new FormArray([createSlotFormGroup({ startTime: '', endTime: '' })]),
    },
    { validators: [noOverlapValidator()] },
  );
}
